interface PrettySelectOption {
    value: string;
    label: string;
}

interface PrettySelectComponent {
    open: boolean;
    value: string;
    options: PrettySelectOption[];
    $refs: {
        select?: HTMLSelectElement;
    };
    selected: PrettySelectOption;
    getOptionLabel(value: string, fallback?: string): string;
    init(): void;
    selectOption(value: string): void;
}

declare global {
    interface Window {
        selectPretty: () => PrettySelectComponent;
    }
}

const fallbackOption: PrettySelectOption = {
    value: '',
    label: '',
};

const readOptions = (select: HTMLSelectElement): PrettySelectOption[] => {
    return Array.from(select.options).map((option) => ({
        value: option.value,
        label: option.text,
    }));
};

const SelectPretty = (): PrettySelectComponent => ({
    open: false,
    value: '',
    options: [],
    $refs: {},
    get selected() {
        return this.options.find((option) => option.value === this.value) || this.options[0] || fallbackOption;
    },
    getOptionLabel(value: string, fallback = '') {
        return this.options.find((option) => option.value === value)?.label || fallback;
    },
    init() {
        const select = this.$refs.select;

        if (!select) {
            return;
        }

        const syncFromSelect = (): void => {
            this.options = readOptions(select);
            this.value = select.value || this.options[0]?.value || '';
        };

        syncFromSelect();
        select.addEventListener('change', syncFromSelect);
    },
    selectOption(nextValue: string) {
        const select = this.$refs.select;

        if (!select) {
            return;
        }

        this.open = false;

        if (select.value === nextValue) {
            this.value = nextValue;
            return;
        }

        select.value = nextValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
    },
});

export { SelectPretty };